import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiNeutralOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M6.987 7.032H4.321v-1.4h2.666z" fill="currentColor" />
            <path d="M8.987 7.032h2.666v-1.4H8.987z" fill="currentColor" />
            <path d="M5.988 12.03h3.999v-1.4h-4z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.49 8c0-6.562.937-7.5 7.5-7.5s7.5.938 7.5 7.5-.938 7.5-7.5 7.5S.49 14.563.49 8m1.4 0c0-1.63.06-2.808.224-3.681.162-.86.4-1.287.654-1.54s.68-.492 1.54-.654C5.18 1.96 6.359 1.9 7.989 1.9s2.808.06 3.681.225c.86.162 1.287.4 1.54.654.253.253.492.68.654 1.54.165.873.225 2.051.225 3.681s-.06 2.808-.225 3.681c-.162.86-.4 1.287-.654 1.54-.253.253-.68.492-1.54.654-.873.165-2.051.225-3.68.225s-2.809-.06-3.682-.225c-.86-.162-1.286-.4-1.54-.654-.253-.253-.492-.68-.654-1.54-.165-.873-.225-2.051-.225-3.681"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiNeutralOutlinedSize16Glyph.displayName = 'EmojiNeutralOutlinedSize16Glyph';
